module.exports = __webpack_public_path__ + "static/media/poetry.ab88fc15.webp";